<template lang="pug">
.side-menu
	nav.menu-nav(v-if="user")
		ul.menu
			template(v-for="item in menuItems", :key="item.name || item.title")
				li(
					v-if="!item.permission || user.permissions[item.permission]",
					:class="menuItemClass(item)"
				)
					router-link(v-if="item.link", :to="item.link")
						i.menu-icon.la(:class="'la-' + item.icon")
						span.menu-label {{ item.title }}
					router-link(v-else-if="item.name && !item.children", :to="{ name: item.name }")
						i.menu-icon.la(:class="'la-' + item.icon")
						span.menu-label {{ item.title }}
					a(v-else, href="javascript:void(0)", @click="toggleMenu(item)")
						i.menu-icon.la(:class="'la-' + item.icon")
						span.menu-label {{ item.title }}
						i.menu-arrow.la.la-angle-down(v-if="item.children")
					ul(v-if="item.children")
						template(v-for="subItem in item.children", :key="subItem.name")
							li(v-if="!subItem.permission || user.permissions[subItem.permission]")
								router-link(:to="{ name: subItem.name }")
									i.menu-icon.menu-icon--sub.la(:class="'la-' + subItem.icon")
									span.menu-label {{ subItem.title }}
	.side-menu-footer(v-if="footerText") {{ footerText }}
</template>

<script>
import { mapState } from "pinia";
import { useAuthStore } from "@/stores/auth";

export default {
	name: "SideMenu",
	data() {
		return {
			activeMenu: null,
			menuItems: [],
			footerText: null,
		};
	},
	computed: {
		...mapState(useAuthStore, ["user"]),
	},
	watch: {
		"$route.name"(name) {
			this.syncExpandedMenu(name);
		},
	},
	mounted() {
		const user = this.user;
		const isPublisher = user.type === "publisher" || (user.type === "admin" && user.publisher_id);
		const isAdvertiser = user.type === "advertiser" || (user.type === "admin" && user.advertiser_id);

		const externalCostDataItems = [];
		if (user.config?.externalCostData && user.permissions?.["reports::EXTERNAL_COST_DATA"]) {
			externalCostDataItems.push({ title: "External Cost Data", name: "external-cost-data", icon: "file-alt" });
		}

		this.footerText = import.meta.env.VUE_APP_FOOTER_TEXT || null;



		const menuItems = [];

		if (isAdvertiser) {
			menuItems.push({ title: "Dashboard", icon: "th-large", name: "dashboard" });
			menuItems.push({ title: "Reports", icon: "chart-bar", name: "statistics" });
			menuItems.push({ title: "Offers", icon: "tags", name: "offer-list" });
			if (user.features?.apiStatsEnabled) {
				menuItems.push({
					title: "API",
					icon: "code",
					name: "advertiser-api",
				});
			}
		} else if (isPublisher) {
			menuItems.push({
				title: "Reports",
				icon: "chart-bar",
				children: [
					{ title: "Performance", name: "statistics", icon: "chart-line" },
					{ title: "Conversions", name: "conversions", icon: "exchange" },
					{ title: "Rejected Installs", name: "rejected", icon: "ban", permission: "rejected::VIEW" },
					{ title: "Postback Log", name: "postback-log", icon: "paper-plane" },
					...externalCostDataItems,
				],
			});
			menuItems.push({ title: "Offers", icon: "tags", name: "offer-list" });
			menuItems.push({
				title: "Payments",
				icon: "wallet",
				name: "publisher-payments",
				permission: "payments::VIEW",
			});
			menuItems.push({
				title: "Settings",
				icon: "cog",
				name: "publisher-settings",
			});
			menuItems.push({
				title: "API",
				icon: "code",
				name: "api",
			});
		}

		this.menuItems = menuItems;
		this.syncExpandedMenu(this.$route.name);
	},
	methods: {
		isReportRoute(name) {
			return ["statistics", "conversions", "events", "rejected", "postback-log", "external-cost-data"].includes(name);
		},
		syncExpandedMenu(routeName) {
			const reportsItem = this.menuItems.find((item) => item.children?.length);
			if (reportsItem && this.isReportRoute(routeName)) {
				this.activeMenu = reportsItem;
			}
		},
		menuItemClass(item) {
			const expanded = item === this.activeMenu;
			const hasActiveChild = item.children?.some((c) => c.name === this.$route.name);
			return {
				expanded,
				active: hasActiveChild,
			};
		},
		toggleMenu(item) {
			this.activeMenu = this.activeMenu === item ? null : item;
		},
	},
};
</script>
